export default __webpack_public_path__ + "static/media/img-c-00-btn-gtl@3x.30d95784.png";